import React, { useState } from 'react';

import { CompanySearchMap, CompanySearchList } from '/components/company-search/components';

const CompanySearch = () => {
    const [activeHit, setActiveHit] = useState(null);

    return (
        <div className="company-search">
            <CompanySearchMap activeHit={activeHit} setActiveHit={setActiveHit} />
            <CompanySearchList activeHit={activeHit} setActiveHit={setActiveHit} />
        </div>
    );
};

export { CompanySearch };
